import React, { useEffect, useState } from "react";

import HeaderPlantila from "./components/HeaderPlantilla";
import PlantillaGrid from "./components/PlantillaGrid";
import './index.css'
import { useGetPlantillaFromTeam } from "./hooks/useGetPlantilla";
import useWindowTop from "../../hooks/useWindowTop";

const PlantillaTeamScreen = ()=>{
    const {plantilla,team} = useGetPlantillaFromTeam()
    useWindowTop();
    
    return(
        <div className="container-plantilla-team" >
            <div className="subcontainer-plantilla-team">
                <HeaderPlantila team={team} />
                <PlantillaGrid plantilla={plantilla} />

            </div>

        </div>
    )

}

export default PlantillaTeamScreen